import {
  DEFAULT_CURRENCY,
  cherrySymbolImg,
  goldNuggetSymbolImg,
  jackpotCrownSymbolImg,
  kunduDrumSymbolImg,
  kumulBirdSymbolImg,
  polCoinSymbolImg,
  diamondSymbolImg,
  btcCoinSymbolImg,
  lucky7SymbolImg,
  jackpotOrbSymbolImg,
} from "../../../../static/Constants";

/**
 * 1 Dropdown with exactly 2 Options: Fiat Pokies vs Crypto Pokies
 */
export const POKIES_TYPE_OPTIONS = [
  {
    id: "fiat",
    label: "Fiat Pokies",
    badge: "Fiat Pokies",
    description:
      "Fiat pokies symbols: Cherry (Mini), Gold Nugget (Major), Royal Crown (Mega Jackpot), Kundu Drum (5 Free Spins) & Kumul Bird (10 Super Spins).",
    defaultCurrency: DEFAULT_CURRENCY || "POL",
  },
  {
    id: "crypto",
    label: "Crypto Pokies",
    badge: "Crypto Pokies",
    description:
      "Crypto pokies symbols: Polygon POL (Mini), Diamond (Major), Bitcoin BTC (Mega Jackpot), Lucky 7 (5 Free Spins) & Jackpot Orb (10 Super Spins).",
    defaultCurrency: DEFAULT_CURRENCY || "POL",
  },
];

/**
 * FIAT Pokies 5-Symbol Set (Contract Mapped 0 to 4)
 * 0: Mini Jackpot (Min Bet) -> Cherry
 * 1: Major Jackpot -> Gold Nugget
 * 2: Mega Jackpot -> Royal Crown
 * 3: 5 Free Spins -> Kundu Drum
 * 4: 10 Super Free Spins -> Kumul Bird
 */
export const FIAT_SET_SYMBOLS = [
  {
    contractNumber: 0,
    id: "cherry",
    label: "Cherry (Mini Jackpot)",
    winningTier: "Mini Jackpot",
    winOutcome: "Mini Bet / Mini Jackpot",
    code: "CHERRY",
    symbolText: "🍒",
    iconText: "🍒",
    multiplier: 10,
    tier: "Mini Jackpot",
    tierColor: "#10b981",
    color: "#ef4444",
    type: "fiat",
    image: cherrySymbolImg,
    payout: "Mini Jackpot (Min Bet Win)",
    description: "Match 3 Cherries to win Mini Progressive Jackpot & Min Bet payout",
  },
  {
    contractNumber: 1,
    id: "gold_nugget",
    label: "Gold Nugget (Major Jackpot)",
    winningTier: "Major Jackpot",
    winOutcome: "Major Jackpot",
    code: "GOLD",
    symbolText: "🪙",
    iconText: "🪙",
    multiplier: 30,
    tier: "Major Jackpot",
    tierColor: "#3b82f6",
    color: "#3b82f6",
    type: "fiat",
    image: goldNuggetSymbolImg,
    payout: "Major Jackpot",
    description: "Match 3 Gold Nuggets to win Major Progressive Jackpot",
  },
  {
    contractNumber: 2,
    id: "jackpot_crown",
    label: "Royal Crown (Mega Jackpot)",
    winningTier: "Mega Jackpot",
    winOutcome: "Mega Jackpot",
    code: "CROWN",
    symbolText: "👑",
    iconText: "👑",
    multiplier: 50,
    tier: "Mega Jackpot",
    tierColor: "#f59e0b",
    color: "#d97706",
    type: "fiat",
    image: jackpotCrownSymbolImg,
    payout: "Mega Jackpot",
    description: "Match 3 Crowns to win Grand Mega Progressive Jackpot",
  },
  {
    contractNumber: 3,
    id: "kundu_drum",
    label: "Kundu Drum (5 Free Spins)",
    winningTier: "5 Free Spins",
    winOutcome: "5 Free Spins",
    code: "DRUM",
    symbolText: "🪘",
    iconText: "🪘",
    multiplier: 15,
    tier: "5 Free Spins",
    tierColor: "#8b5cf6",
    color: "#8b5cf6",
    type: "fiat",
    image: kunduDrumSymbolImg,
    payout: "5 Free Spins",
    description: "Match 3 Kundu Drums to trigger 5 Free Spins Bonus Round",
  },
  {
    contractNumber: 4,
    id: "kumul_bird",
    label: "Kumul Bird (10 Super Spins)",
    winningTier: "10 Super Spins",
    winOutcome: "10 Super Spins (2x Win)",
    code: "BIRD",
    symbolText: "🦅",
    iconText: "🦅",
    multiplier: 25,
    tier: "10 Super Spins",
    tierColor: "#dc2626",
    color: "#dc2626",
    type: "fiat",
    image: kumulBirdSymbolImg,
    payout: "10 Super Spins (2x)",
    description: "Match 3 Kumul Birds for 10 Super Free Spins + 2x Win Multiplier",
  },
];

/**
 * CRYPTO Pokies 5-Symbol Set (Contract Mapped 0 to 4)
 * 0: Mini Jackpot (Min Bet) -> Polygon POL
 * 1: Major Jackpot -> Diamond
 * 2: Mega Jackpot -> Bitcoin BTC
 * 3: 5 Free Spins -> Lucky 7
 * 4: 10 Super Free Spins -> Jackpot Orb
 */
export const CRYPTO_SET_SYMBOLS = [
  {
    contractNumber: 0,
    id: "pol",
    label: "Polygon POL (Mini Jackpot)",
    winningTier: "Mini Jackpot",
    winOutcome: "Mini Bet / Mini Jackpot",
    code: "POL",
    symbolText: "🟣",
    iconText: "🟣",
    multiplier: 10,
    tier: "Mini Jackpot",
    tierColor: "#10b981",
    color: "#10b981",
    type: "crypto",
    image: polCoinSymbolImg,
    payout: "Mini Jackpot (Min Bet Win)",
    description: "Match 3 POL to win Mini Progressive Jackpot & Min Bet payout",
  },
  {
    contractNumber: 1,
    id: "diamond",
    label: "Diamond (Major Jackpot)",
    winningTier: "Major Jackpot",
    winOutcome: "Major Jackpot",
    code: "DIAMOND",
    symbolText: "💎",
    iconText: "💎",
    multiplier: 30,
    tier: "Major Jackpot",
    tierColor: "#3b82f6",
    color: "#3b82f6",
    type: "crypto",
    image: diamondSymbolImg,
    payout: "Major Jackpot",
    description: "Match 3 Diamonds to win Major Progressive Jackpot",
  },
  {
    contractNumber: 2,
    id: "btc",
    label: "Bitcoin BTC (Mega Jackpot)",
    winningTier: "Mega Jackpot",
    winOutcome: "Mega Jackpot",
    code: "BTC",
    symbolText: "₿",
    iconText: "₿",
    multiplier: 50,
    tier: "Mega Jackpot",
    tierColor: "#f59e0b",
    color: "#d97706",
    type: "crypto",
    image: btcCoinSymbolImg,
    payout: "Mega Jackpot",
    description: "Match 3 Bitcoins to win Grand Mega Progressive Jackpot",
  },
  {
    contractNumber: 3,
    id: "lucky_7",
    label: "Lucky 7 (5 Free Spins)",
    winningTier: "5 Free Spins",
    winOutcome: "5 Free Spins",
    code: "SEVEN",
    symbolText: "7️⃣",
    iconText: "7️⃣",
    multiplier: 15,
    tier: "5 Free Spins",
    tierColor: "#8b5cf6",
    color: "#8b5cf6",
    type: "crypto",
    image: lucky7SymbolImg,
    payout: "5 Free Spins",
    description: "Match 3 Lucky 7s to trigger 5 Free Spins Web3 Bonus Round",
  },
  {
    contractNumber: 4,
    id: "jackpot_orb",
    label: "Jackpot Orb (10 Super Spins)",
    winningTier: "10 Super Spins",
    winOutcome: "10 Super Spins (2x Win)",
    code: "ORB",
    symbolText: "🔮",
    iconText: "🔮",
    multiplier: 25,
    tier: "10 Super Spins",
    tierColor: "#dc2626",
    color: "#dc2626",
    type: "crypto",
    image: jackpotOrbSymbolImg,
    payout: "10 Super Spins (2x)",
    description: "Match 3 Jackpot Orbs for 10 Super Free Spins + 2x Win Multiplier",
  },
];

/**
 * Helper to get the 5 symbols mapped from 0 to 4 based on the 2 dropdown options (Fiat or Crypto)
 */
export const getSymbolsByCategory = (category = "fiat") => {
  if (category === "crypto") {
    return CRYPTO_SET_SYMBOLS;
  }
  return FIAT_SET_SYMBOLS;
};
